import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import type { DateTime } from 'luxon';

@Component({
    selector: 'app-date',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateComponent {
    @Input() date: DateTime | string;
    @Input() short = false;
}
